<div class="dot-container">
  <span class="dot" [class.active]="isActive$ | async" [style.width.px]="dotDiameter" [style.height.px]="dotDiameter" [style.background]="(isActive$ | async) ? dotActiveColour : dotInactiveColour">
  </span>
</div>